import { render } from "./PracticePlan.vue?vue&type=template&id=ab6cc354&scoped=true"
import script from "./PracticePlan.vue?vue&type=script&lang=js"
export * from "./PracticePlan.vue?vue&type=script&lang=js"

import "./PracticePlan.vue?vue&type=style&index=0&id=ab6cc354&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab6cc354"]])

export default __exports__